module.exports = __webpack_public_path__ + "img/circle-green.e3da06cb.svg";